import React from 'react'
import BookForm from './BookForm'
import {Modal} from 'react-bootstrap'


const BookEdit = ({show,handleModalClose,handleSubmit,book,subjects}) => (
  <div>
    <Modal show={show} backdrop="static" keyboard={false} onHide={() => handleModalClose(false)}>
        <Modal.Header closeButton>
            <Modal.Title>Buch bearbeiten</Modal.Title>
        </Modal.Header>
          <BookForm
             handleSubmit={handleSubmit} book={book} subjects={subjects}
            />
        </Modal>
  </div>
)

export default BookEdit